import { Stack } from "@mui/material";
import { type ReactNode, useState } from "react";
import { useLoyaltiesLeaderboardQuery } from "Api/Queries/Loyalty/useLoyaltiesLeaderboardQuery";
import { Leaderboard } from "Components/Loyalty/Shared/Leaderboard/Leaderboard";
import { LoyaltyPeriodSelector } from "Components/Loyalty/Shared/PeriodSelect/LoyaltyPeriodSelector";
import type { LoyaltyPointType } from "Infrastructure/Api/Api";

type Props = {
  pointType: LoyaltyPointType;
  title: string;
  scoreIcon: ReactNode;
};

export const LoyaltyLeaderboardSection = ({
  pointType,
  title,
  scoreIcon,
}: Props) => {
  const [settlementPeriodId, setSettlementPeriodId] = useState<number>();

  const { data, isLoading, isError } = useLoyaltiesLeaderboardQuery({
    pointType,
    settlementPeriodId,
  });

  return (
    <Stack gap={4}>
      <LoyaltyPeriodSelector onPeriodChange={setSettlementPeriodId} />
      {/* key remounts the leaderboard per period — avoids cross-period diffing */}
      <Leaderboard
        key={settlementPeriodId ?? "current"}
        title={title}
        items={data?.items}
        isLoading={isLoading}
        isError={isError}
        scoreIcon={scoreIcon}
      />
    </Stack>
  );
};
